import { observable, action, runInAction, computed } from "mobx";
import agent from "../agent";
import templateStore from "./templateStore";
import profileStore from "./profileStore";

import reportStore from "./reportStore";

import moment from "moment";

class InvoiceStore {
    @observable inProgress = false;
    @observable errors = undefined;

    @observable id = undefined;

    @observable incomingInvoices = [];

    @observable outgoingInvoices = [];

    @observable invoiceReports = [];

    @observable invoiceReportDateStart = undefined;
    @observable invoiceReportDateEnd = undefined;
    @observable invoice = undefined;

    @observable selectedIncomingInvoice = undefined;

    @observable selectedOutgoingPdfBatch = undefined;

    @observable purchaseOrderCode = undefined;

    @observable filter = {
        contactName: undefined
    }

    @observable incomingPage = 0;

    @observable outgoingPage = 0;

    @observable showMoreIncoming = false;

    @observable showMoreOutgoing = false;

    @observable outgoingPaginationState = {
        currentPage: 1,
        pageSize: 30,
        totalLoaded: 0,
        isLoadingAll: false,
        loadAllProgress: 0,
        loadAllCancelled: false,
        cachedPages: {}
    };

    @observable incomingPaginationState = {
        currentPage: 1,
        pageSize: 30,
        totalLoaded: 0,
        isLoadingAll: false,
        loadAllProgress: 0,
        loadAllCancelled: false,
        cachedPages: {}
    };

    @observable outgoingSearchTerm = "";
    @observable incomingSearchTerm = "";
    @observable isSearchingOutgoing = false;
    @observable isSearchingIncoming = false;

    @action
    setOutgoingSearchTerm(term) {
        this.outgoingSearchTerm = term;
    }

    @action
    setIncomingSearchTerm(term) {
        this.incomingSearchTerm = term;
    }

    @action
    clearOutgoingSearch() {
        this.outgoingSearchTerm = "";
    }

    @action
    clearIncomingSearch() {
        this.incomingSearchTerm = "";
    }

    @computed
    get filteredOutgoingInvoices() {
        return this.outgoingInvoices;
    }

    @computed
    get filteredIncomingInvoices() {
        return this.incomingInvoices;
    }

    @action
    searchOutgoingInvoices(payeeId) {
        const { currentProfile } = profileStore;
        if (!payeeId) {
            payeeId = currentProfile?.id;
        }
        this.isSearchingOutgoing = true;
        this.outgoingInvoices = [];
        this.showMoreOutgoing = false;
        this.outgoingPaginationState.currentPage = 1;
        this.outgoingPaginationState.totalLoaded = 0;
        this.outgoingPaginationState.cachedPages = {};

        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId, bookingType } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();
        const { pageSize } = this.outgoingPaginationState;
        const searchTerm = this.outgoingSearchTerm.trim() || undefined;

        if (!searchTerm) {
            this.isSearchingOutgoing = false;
            return Promise.resolve([]);
        }

        return agent.Invoice.getByPayeeIdAndFilter(payeeId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, 1, pageSize, this.filter.contactName, bookingType, searchTerm).then(
            action(result => {
                var invoices = result.invoices || [];
                invoices.forEach(invoice => {
                    var payeeName = invoice.payeeName;
                    var payerName = invoice.payerName;
                    if (invoice.payee) {
                        payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName;
                    }
                    if (invoice.payer) {
                        payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName;
                    }
                    invoice.payerName = payerName;
                    invoice.payeeName = payeeName;
                });
                this.outgoingInvoices = invoices;
                this.showMoreOutgoing = result.isMore;
                this.outgoingPage = 1;
                this.outgoingPaginationState.currentPage = 1;
                this.outgoingPaginationState.totalLoaded = invoices.length;
                this.isSearchingOutgoing = false;
                return this.outgoingInvoices;
            })
        ).catch(action(err => {
            this.isSearchingOutgoing = false;
            throw err;
        }));
    }

    @action
    searchIncomingInvoices(payerId) {
        const { currentProfile } = profileStore;
        if (!payerId) {
            payerId = currentProfile?.id;
        }
        this.isSearchingIncoming = true;
        this.incomingInvoices = [];
        this.showMoreIncoming = false;
        this.incomingPaginationState.currentPage = 1;
        this.incomingPaginationState.totalLoaded = 0;
        this.incomingPaginationState.cachedPages = {};

        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId, bookingType } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();
        const { pageSize } = this.incomingPaginationState;
        const searchTerm = this.incomingSearchTerm.trim() || undefined;

        if (!searchTerm) {
            this.isSearchingIncoming = false;
            return Promise.resolve([]);
        }

        return agent.Invoice.getByPayerIdAndFilter(payerId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, 1, pageSize, this.filter.contactName, bookingType, searchTerm).then(
            action(result => {
                var invoices = result.invoices || [];
                invoices.forEach(invoice => {
                    var payeeName = invoice.payeeName;
                    var payerName = invoice.payerName;
                    if (invoice.payee) {
                        payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName;
                    }
                    if (invoice.payer) {
                        payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName;
                    }
                    invoice.payerName = payerName;
                    invoice.payeeName = payeeName;
                });
                this.incomingInvoices = invoices;
                this.showMoreIncoming = result.isMore;
                this.incomingPage = 1;
                this.incomingPaginationState.currentPage = 1;
                this.incomingPaginationState.totalLoaded = invoices.length;
                this.isSearchingIncoming = false;
                return this.incomingInvoices;
            })
        ).catch(action(err => {
            this.isSearchingIncoming = false;
            throw err;
        }));
    }

    @action
    resetInvoicePage(){
        this.incomingPage = 1;
        this.outgoingPage = 1;
        this.outgoingInvoices= []
        this.incomingInvoices = []
        this.showMoreOutgoing = false
        this.showMoreIncoming = false
        this.resetOutgoingPaginationState();
        this.resetIncomingPaginationState();
        this.outgoingSearchTerm = "";
        this.incomingSearchTerm = "";
    }

    @action
    resetIncomingPage(){
        this.incomingPage = 1;
        this.incomingInvoices = []
        this.showMoreIncoming = false
        this.resetIncomingPaginationState();
    }

    @action
    resetOutgoingPage(){
        this.outgoingPage = 1;
        this.outgoingInvoices = []
        this.showMoreOutgoing = false
        this.resetOutgoingPaginationState();
    }

    @action
    resetOutgoingPaginationState() {
        this.outgoingPaginationState = {
            currentPage: 1,
            pageSize: 30,
            totalLoaded: 0,
            isLoadingAll: false,
            loadAllProgress: 0,
            loadAllCancelled: false,
            cachedPages: {}
        };
    }

    @action
    resetIncomingPaginationState() {
        this.incomingPaginationState = {
            currentPage: 1,
            pageSize: 30,
            totalLoaded: 0,
            isLoadingAll: false,
            loadAllProgress: 0,
            loadAllCancelled: false,
            cachedPages: {}
        };
    }

    @action
    setOutgoingPage(page) {
        this.outgoingPaginationState.currentPage = page;
    }

    @action
    setIncomingPage(page) {
        this.incomingPaginationState.currentPage = page;
    }

    @action
    filterOutgoingInvoiceBaseOnFilter(invoices){
        let outgoingInvoices = [...this.outgoingInvoices];
        if(invoices){
            outgoingInvoices = [...invoices];
        }
        if(this.filter){
            if(this.filter.contactName){
                outgoingInvoices = this.outgoingInvoices.filter(x => x.payerName === this.filter.contactName);
            }
            //..add others filter here
        }
        return outgoingInvoices;
    }

    @action
    filterIncomingInvoiceBaseOnFilter(invoices){
        let incomingInvoices = [...this.incomingInvoices];
        if(invoices){
            incomingInvoices = [...invoices];
        }
        if(this.filter){
            if(this.filter.contactName){
                incomingInvoices = incomingInvoices.filter(x => x.payeeName === this.filter.contactName);
            }
            //..add others filter here
        }
        return incomingInvoices;
    }

    @action
    resetFilter(){
        this.filter = {
            contactName: undefined
        }
    }

    @action
    setFilterAttr(key, value){
        this.filter[key] = value;
    }

    @action
    setPurchaseOrderCode(poCode){
        this.purchaseOrderCode = poCode;
    }

    @action
    setSelectedIncomingInvoice(value){
        this.selectedIncomingInvoice = value;
    }

    @action
    setSelectedOutgoingPdfBatch(value){
        this.selectedOutgoingPdfBatch = value;
    }

    @action
    load() {
        this.inProgress = true;
        templateStore.showLoadingScreen();
        return agent.Invoice.getAll()
            .then(
                action(invoices => {
                    this.invoices = invoices;
                    return this.invoices;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    clearIncomingOutgoingInvoices = () => {
        this.incomingInvoices = [];
        this.outgoingInvoices = [];
    };

    @action
    setInvoices(invoices) {
        this.invoices = invoices;
    }

    @action
    unsyncSendToAccountIncoming(invoiceId) {
        return agent.Invoice.unsyncSendToAccount(invoiceId)
        .then(
            action(invoice => {
                this.incomingInvoices.forEach(item => {
                    if(item.id === invoiceId) {
                        item.synchedSendAccount = false
                    }
                });
                return invoice;
            })
        )
    }

    @action
    unsyncSendToAccountOutgoing(invoiceId) {
        return agent.Invoice.unsyncSendToAccount(invoiceId)
        .then(
            action(invoice => {
                this.outgoingInvoices.forEach(item => {
                    if(item.id === invoiceId) {
                        item.synchedSendAccount = false
                    }
                });
                return invoice;
            })
        )
    }

    @action


    @action
    unsyncXeroInvoiceIncoming(profileId, invoiceId) {
        return agent.Xero.deleteXeroInvoice(profileId, invoiceId)
        .then(
            action(invoice => {
                this.incomingInvoices.forEach(item => {
                    if(item.id === invoiceId) {
                        item.isXeroSyncronise = false
                    }
                });
                return invoice;
            })
        ).catch(
            action(err => {
                return Promise.reject(err);
            })
        )
    }

    @action
    unsyncXeroInvoice(profileId, invoiceId) {
        return agent.Xero.deleteXeroInvoice(profileId, invoiceId)
        .then(
            action(invoice => {
                this.outgoingInvoices.forEach(item => {
                    if(item.id === invoiceId) {
                        item.isXeroSyncronise = false
                    }
                });
                return invoice;
            })
        ).catch(
            action(err => {
                return Promise.reject(err);
            })
        )
    }
    @action
    unsyncSendToAccount(invoiceId) {
        return agent.Invoice.unsyncSendToAccount(invoiceId)
        .then(
            action(invoice => {
                this.incomingInvoices.forEach(item => {
                    if(item.id === invoiceId) {
                        item.synchedSendAccount = false
                    }
                });
                return invoice;
            })
        )
    }

    @action
    loadByPayeeId(payeeId) {
        this.inProgress = true;
        templateStore.showLoadingScreen();
        return agent.Invoice.getByPayeeId(payeeId)
            .then(
                action(invoices => {
                    this.outgoingInvoices = invoices;
                    return this.invoices;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    getBookingCreatorByInvoiceId(invoiceId){
        return agent.Invoice.getBookingCreatorByInvoiceId(invoiceId)
        .then(
            action(bookingCreators => {
                return bookingCreators
            })
        )
    }

    @action
    loadByPayerId(payerId) {
        this.inProgress = true;
        templateStore.showLoadingScreen();
        return agent.Invoice.getByPayerId(payerId)
            .then(
                action(invoices => {
                    this.incomingInvoices = invoices;
                    return this.invoices;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    getInvoiceByBookingAndProfileId(bookingId, profileId) {
        return agent.Invoice.getInvoiceByBookingAndProfileId(bookingId, profileId).then(
            action(invoices => {
                return invoices;
            })
        );
        
    }

    @action
    getByIdSimple(invoiceId) {
        return agent.Invoice.getByIdSimple(invoiceId).then(
            action(invoice => {
                return invoice;
            })
        );
        
    }
    
    @action
    loadByPayeeIdAndFilter(payeeId, page) {
        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId, bookingType} = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();
        const { pageSize } = this.outgoingPaginationState;
        const searchTerm = this.outgoingSearchTerm.trim() || undefined;

        return agent.Invoice.getByPayeeIdAndFilter(payeeId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, page, pageSize, this.filter.contactName, bookingType, searchTerm).then(
            action(result => {
                var invoices = result.invoices

                invoices.forEach(invoice => {
                    var payeeName = invoice.payeeName
                    var payerName = invoice.payerName
                    if(invoice.payee){
                        payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName
                    }
                    if(invoice.payer){
                        payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName
                    }
                    invoice.payerName = payerName
                    invoice.payeeName = payeeName
                });
                this.outgoingInvoices = this.outgoingInvoices.concat(invoices);
                this.showMoreOutgoing = result.isMore
                this.outgoingPage = parseInt(result.page, 10) || 1
                this.outgoingPaginationState.currentPage = parseInt(result.page, 10) || 1;
                this.outgoingPaginationState.totalLoaded = this.outgoingInvoices.length;
                return this.invoices;
            })
        );
    }

    @action
    loadByPayeeIdAndFilterRefresh(payeeId) {
        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId,bookingType  } = reportStore;
        
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();
        const { pageSize } = this.outgoingPaginationState;
        var currentPage = parseInt(this.outgoingPage)
        var limit = parseInt(this.outgoingPage) * pageSize
        const searchTerm = this.outgoingSearchTerm.trim() || undefined;
        this.resetOutgoingPage()
        return agent.Invoice.getByPayeeIdAndFilter(payeeId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, 1, limit, this.filter.contactName,bookingType, searchTerm).then(
            action(result => {
                var invoices = result.invoices
                invoices.forEach(invoice => {
                    var payeeName = invoice.payeeName
                    var payerName = invoice.payerName
                    if(invoice.payee){
                        payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName
                    }
                    if(invoice.payer){
                        payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName
                    }
                    invoice.payerName = payerName
                    invoice.payeeName = payeeName
                });
                this.outgoingInvoices = this.outgoingInvoices.concat(invoices);
                this.showMoreOutgoing = result.isMore
                this.outgoingPage = currentPage
                return this.invoices;
            })
        );
    }

    @action
    loadByPayerIdAndFilter(payerId,page) {
        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId, bookingType} = reportStore;

        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();
        const { pageSize } = this.incomingPaginationState;
        const searchTerm = this.incomingSearchTerm.trim() || undefined;

        return agent.Invoice.getByPayerIdAndFilter(payerId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, page, pageSize, this.filter.contactName, bookingType, searchTerm).then(
            action(result => {
                var invoices = result.invoices
                invoices.forEach(invoice => {
                    var payeeName = invoice.payeeName
                    var payerName = invoice.payerName
                    if(invoice.payee){
                        payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName
                    }
                    if(invoice.payer){
                        payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName
                    }
                    invoice.payerName = payerName
                    invoice.payeeName = payeeName
                });
                

                this.incomingInvoices = this.incomingInvoices.concat(invoices);
                this.showMoreIncoming = result.isMore
                this.incomingPage = parseInt(result.page, 10) || 1
                this.incomingPaginationState.currentPage = parseInt(result.page, 10) || 1;
                this.incomingPaginationState.totalLoaded = this.incomingInvoices.length;
                return this.invoices;
            })
        );
    }

    @action
    loadByPayerIdAndFilterRefresh(payerId) {
        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId, bookingType } = reportStore;

        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();
        const { pageSize } = this.incomingPaginationState;
       
        var currentPage = parseInt(this.incomingPage)
        var limit = parseInt(this.incomingPage) * pageSize
        const searchTerm = this.incomingSearchTerm.trim() || undefined;
        this.resetIncomingPage()
        return agent.Invoice.getByPayerIdAndFilter(payerId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, 1, limit, this.filter.contactName, bookingType, searchTerm).then(
            action(result => {
                var invoices = result.invoices
                this.incomingPage = currentPage + 1
                invoices.forEach(invoice => {
                    var payeeName = invoice.payeeName
                    var payerName = invoice.payerName
                    if(invoice.payee){
                        payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName
                    }
                    if(invoice.payer){
                        payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName
                    }
                    invoice.payerName = payerName
                    invoice.payeeName = payeeName
                });
                

                this.incomingInvoices = this.incomingInvoices.concat(invoices);
                this.showMoreIncoming = result.isMore
                this.incomingPage = currentPage
                return this.invoices;
            })
        );
    }
   
    @action
    getById(invoiceId) {
        this.inProgress = true;
        return agent.Invoice.get(invoiceId)
            .then(
                action(response => {
                    this.invoice = response;
                    return response;
                })
            )
            .finally(() => {
                this.inProgress = false;
            });
    }

    @action
    getByIdProfileId(invoiceId,profileId) {
        this.inProgress = true;
        return agent.Invoice.getProfileId(invoiceId,profileId)
            .then(
                action(response => {
                    this.invoice = response;
                    return response;
                })
            )
            .finally(() => {
                this.inProgress = false;
            });
    }

    @action
    delete(id) {
        return agent.Profile.delete(id).then(
            action(response => {
                let invoice = this.invoices.find(x => x.id === id);
                if (invoice) this.invoices.remove(invoice);
                return response;
            })
        );
    }

    @action
    generate(id) {
        return agent.Invoice.generate(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    this.errors = err.response && err.response.body && err.response.body.errors;
                    throw err;
                })
            );
    }
    
    @action
    unPayInvoice(invoiceId, data) {
        this.inProgress = true;
        templateStore.showLoadingScreen();

        return agent.Invoice.unPayInvoice(invoiceId, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    updatePaidDate(invoiceId, data) {
        this.inProgress = true;
        templateStore.showLoadingScreen();

        return agent.Invoice.updatePaidDate(invoiceId, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }
    @action
    payInvoice(invoiceId, data) {
        this.inProgress = true;
        templateStore.showLoadingScreen();

        return agent.Invoice.payInvoice(invoiceId, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    markOutstandingInvoice(invoiceId) {
        this.inProgress = true;
        templateStore.showLoadingScreen();

        return agent.Invoice.markOutstanding(invoiceId)
            .then(
                action(response => {
                    const updatedInvoice = response || {};
                    this.outgoingInvoices = this.outgoingInvoices.map(invoice =>
                        invoice.id === invoiceId
                            ? {
                                ...invoice,
                                ...updatedInvoice,
                                status: updatedInvoice.status || "outstanding"
                            }
                            : invoice
                    );
                    return updatedInvoice;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    declineInvoice(invoiceId) {
        this.inProgress = true;
        templateStore.showLoadingScreen();

        return agent.Invoice.declineInvoice(invoiceId)
            .then(
                action(response => {
                    return response;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    downloadInvoicePdf(id) {
        return agent.Invoice.downloadPdf(id).then(response => {
            return response;
        });
    }

    @action
    downloadBatchInvoicePdf(ids){
        return agent.Invoice.downloadBatchPdf(ids).then(response => {
            return response;
        })
    }

    @action
    resetInvoiceReports() {
        this.invoiceReports = [];
    }

    @action
    generateInvoicesReport() {
        const { currentProfile } = profileStore;
        const { startDate, endDate, organisationId, stateId, regionId, venueId, statusFilter } = reportStore;

        return agent.Invoice.generateReport(
            currentProfile.type,
            moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS"),
            moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS"),
            organisationId,
            stateId,
            regionId,
            venueId,
            statusFilter !== "all" ? statusFilter : ""
        ).then(
            action(response => {
                this.invoiceReports = response;
                return this.invoiceReports;
            })
        );
    }

    @action
    readyToPayCheck(invoiceIds){
        const { currentProfile } = profileStore;
        var data = {
            invoiceIds: invoiceIds,
        };
        return agent.Invoice.readyToPayCheck(currentProfile?.id,data).then(action(
            response => {
                return response;
            }
        ))
    }

    @action
    updateStatusIncomingInvoice(invoiceId){
        this.incomingInvoices.forEach((invoice) => {
            if(invoice.id === invoiceId){
                if(moment(invoice.dueDate).isBefore(moment())){
                    invoice.status = "overdue"
                }else{
                    invoice.status = "outstanding"
                }
            }
        })
    }
    @action
    updateStatusOutgoingInvoice(invoiceId){
        this.outgoingInvoices.forEach((invoice) => {
            if(invoice.id === invoiceId){
                if(moment(invoice.dueDate).isBefore(moment())){
                    invoice.status = "overdue"
                }else{
                    invoice.status = "outstanding"
                }
            }
        })
    }

    @action
    outgoingMarksAsPaid(invoiceId){
        this.outgoingInvoices.forEach((invoice) => {
            if(invoice.id === invoiceId){
                invoice.status = "paid"
            }
        })

    }

    @action
    incomingMarksAsPaid(invoiceId){
        this.incomingInvoices.forEach((invoice) => {
            if(invoice.id === invoiceId){
                invoice.status = "paid"
            }
        })

        // this.incomingInvoices = this.incomingInvoices
    }


    @action
    updateInvoicesPurchaseOrder(invoiceIds){
        if(!invoiceIds && this.selectedIncomingInvoice){
            invoiceIds = this.selectedIncomingInvoice.map(x => x.id);
        }
        var data = {
            invoiceIds: invoiceIds,
            purchaseOrderCode: this.purchaseOrderCode
        };
        return agent.Invoice.updateInvoicesPurchaseOrder(data).then(action(
            response => {
                response.forEach(invoice => {
                    this.incomingInvoices = this.incomingInvoices.map(x => {
                        if (x.id === invoice.id) {
                            x.purchaseOrderCode = invoice.purchaseOrderCode;
                            x.synchedSendAccount = invoice.synchedSendAccount;
                        }
                        return x;
                    });
                })
                return response;
            }
        ))
    }

    @action
    async loadAllOutgoingInvoices(payeeId) {
        const { currentProfile } = profileStore;
        if (!payeeId) {
            payeeId = currentProfile?.id;
        }

        runInAction(() => {
            this.outgoingPaginationState.isLoadingAll = true;
            this.outgoingPaginationState.loadAllCancelled = false;
            this.outgoingPaginationState.loadAllProgress = 0;
        });

        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId, bookingType } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();

        const { pageSize } = this.outgoingPaginationState;
        const CONCURRENT_REQUESTS = 4;
        const searchTerm = this.outgoingSearchTerm.trim() || undefined;
        let allInvoices = [];
        let currentBatchStart = 1;
        let hasMore = true;
        let totalPages = null;

        try {
            while (hasMore && !this.outgoingPaginationState.loadAllCancelled) {
                const pageNumbers = [];
                for (let i = 0; i < CONCURRENT_REQUESTS; i++) {
                    pageNumbers.push(currentBatchStart + i);
                }

                const batchPromises = pageNumbers.map(pageNum =>
                    agent.Invoice.getByPayeeIdAndFilter(payeeId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, pageNum, pageSize, this.filter.contactName, bookingType, searchTerm)
                        .then(result => ({ pageNum, result }))
                        .catch(error => ({ pageNum, error }))
                );

                const batchResults = await Promise.all(batchPromises);
                batchResults.sort((a, b) => a.pageNum - b.pageNum);

                let batchHadError = false;
                for (const { pageNum, result, error } of batchResults) {
                    if (this.outgoingPaginationState.loadAllCancelled) break;
                    if (!hasMore) break;

                    if (error) {
                        console.error(`Error loading outgoing invoice page ${pageNum}:`, error);
                        batchHadError = true;
                        break;
                    }

                    const invoices = result?.invoices || [];

                    if (invoices.length === 0 && pageNum > 1) {
                        hasMore = false;
                        break;
                    }

                    invoices.forEach(invoice => {
                        let payeeName = invoice.payeeName;
                        let payerName = invoice.payerName;
                        if (invoice.payee) {
                            payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName;
                        }
                        if (invoice.payer) {
                            payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName;
                        }
                        invoice.payerName = payerName;
                        invoice.payeeName = payeeName;
                        allInvoices.push(invoice);
                    });

                    if (!result?.isMore) {
                        hasMore = false;
                        totalPages = pageNum;
                    }
                }

                if (batchHadError) {
                    throw new Error("Failed to load some invoice pages. Please try again.");
                }

                const progress = totalPages
                    ? Math.min(99, (currentBatchStart + CONCURRENT_REQUESTS - 1) / totalPages * 100)
                    : Math.min(90, allInvoices.length / (allInvoices.length + pageSize * 2) * 100);

                runInAction(() => {
                    this.outgoingInvoices = [...allInvoices];
                    this.outgoingPaginationState.totalLoaded = allInvoices.length;
                    this.outgoingPaginationState.loadAllProgress = progress;
                });

                currentBatchStart += CONCURRENT_REQUESTS;
            }

            if (!this.outgoingPaginationState.loadAllCancelled) {
                runInAction(() => {
                    this.outgoingInvoices = allInvoices;
                    this.showMoreOutgoing = false;
                    this.outgoingPaginationState.currentPage = 1;
                    this.outgoingPaginationState.loadAllProgress = 100;
                    this.outgoingPaginationState.totalLoaded = allInvoices.length;
                    this.outgoingPaginationState.cachedPages = { 1: allInvoices };
                });
            }

            return this.outgoingInvoices;
        } catch (error) {
            console.error("Load all outgoing invoices failed:", error);
            runInAction(() => {
                this.outgoingPaginationState.isLoadingAll = false;
            });
            throw error;
        } finally {
            runInAction(() => {
                this.outgoingPaginationState.isLoadingAll = false;
            });
        }
    }

    @action
    cancelLoadAllOutgoing() {
        this.outgoingPaginationState.loadAllCancelled = true;
        this.outgoingPaginationState.isLoadingAll = false;
    }

    @action
    async loadAllIncomingInvoices(payerId) {
        const { currentProfile } = profileStore;
        if (!payerId) {
            payerId = currentProfile?.id;
        }

        runInAction(() => {
            this.incomingPaginationState.isLoadingAll = true;
            this.incomingPaginationState.loadAllCancelled = false;
            this.incomingPaginationState.loadAllProgress = 0;
        });

        const { startDate, endDate, organisationId, stateId, regionId, venueId, invoiceStatusFilter, actId, bookingType } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const statusFilter = invoiceStatusFilter.join().toLowerCase();

        const { pageSize } = this.incomingPaginationState;
        const CONCURRENT_REQUESTS = 4;
        const searchTerm = this.incomingSearchTerm.trim() || undefined;
        let allInvoices = [];
        let currentBatchStart = 1;
        let hasMore = true;
        let totalPages = null;

        try {
            while (hasMore && !this.incomingPaginationState.loadAllCancelled) {
                const pageNumbers = [];
                for (let i = 0; i < CONCURRENT_REQUESTS; i++) {
                    pageNumbers.push(currentBatchStart + i);
                }

                const batchPromises = pageNumbers.map(pageNum =>
                    agent.Invoice.getByPayerIdAndFilter(payerId, startDateFormated, endDateFormated, organisationId, stateId, regionId, venueId, statusFilter, actId, pageNum, pageSize, this.filter.contactName, bookingType, searchTerm)
                        .then(result => ({ pageNum, result }))
                        .catch(error => ({ pageNum, error }))
                );

                const batchResults = await Promise.all(batchPromises);
                batchResults.sort((a, b) => a.pageNum - b.pageNum);

                let batchHadError = false;
                for (const { pageNum, result, error } of batchResults) {
                    if (this.incomingPaginationState.loadAllCancelled) break;
                    if (!hasMore) break;

                    if (error) {
                        console.error(`Error loading incoming invoice page ${pageNum}:`, error);
                        batchHadError = true;
                        break;
                    }

                    const invoices = result?.invoices || [];

                    if (invoices.length === 0 && pageNum > 1) {
                        hasMore = false;
                        break;
                    }

                    invoices.forEach(invoice => {
                        let payeeName = invoice.payeeName;
                        let payerName = invoice.payerName;
                        if (invoice.payee) {
                            payeeName = invoice.payee.profileName ? invoice.payee.profileName : invoice.payee.firstName + " " + invoice.payee.lastName;
                        }
                        if (invoice.payer) {
                            payerName = invoice.payer.profileName ? invoice.payer.profileName : invoice.payer.firstName + " " + invoice.payer.lastName;
                        }
                        invoice.payerName = payerName;
                        invoice.payeeName = payeeName;
                        allInvoices.push(invoice);
                    });

                    if (!result?.isMore) {
                        hasMore = false;
                        totalPages = pageNum;
                    }
                }

                if (batchHadError) {
                    throw new Error("Failed to load some invoice pages. Please try again.");
                }

                const progress = totalPages
                    ? Math.min(99, (currentBatchStart + CONCURRENT_REQUESTS - 1) / totalPages * 100)
                    : Math.min(90, allInvoices.length / (allInvoices.length + pageSize * 2) * 100);

                runInAction(() => {
                    this.incomingInvoices = [...allInvoices];
                    this.incomingPaginationState.totalLoaded = allInvoices.length;
                    this.incomingPaginationState.loadAllProgress = progress;
                });

                currentBatchStart += CONCURRENT_REQUESTS;
            }

            if (!this.incomingPaginationState.loadAllCancelled) {
                runInAction(() => {
                    this.incomingInvoices = allInvoices;
                    this.showMoreIncoming = false;
                    this.incomingPaginationState.currentPage = 1;
                    this.incomingPaginationState.loadAllProgress = 100;
                    this.incomingPaginationState.totalLoaded = allInvoices.length;
                    this.incomingPaginationState.cachedPages = { 1: allInvoices };
                });
            }

            return this.incomingInvoices;
        } catch (error) {
            console.error("Load all incoming invoices failed:", error);
            runInAction(() => {
                this.incomingPaginationState.isLoadingAll = false;
            });
            throw error;
        } finally {
            runInAction(() => {
                this.incomingPaginationState.isLoadingAll = false;
            });
        }
    }

    @action
    cancelLoadAllIncoming() {
        this.incomingPaginationState.loadAllCancelled = true;
        this.incomingPaginationState.isLoadingAll = false;
    }
}

export default new InvoiceStore();
